export enum HighlightCategory {
  UNKNOWN,
  MAINTENANCE,
  TRAINING,
  ANNOUNCEMENT,
  SUCCESSSTORY,
  GENERAL
}
